export const CASHIN_COLLAPSED_EVENTS_LS = 'cashin.collapsed.sport-events';

export const CashinPosition = {
    TICKET_DETAIL: 'TICKET_DETAIL',
    TICKET_LIST: 'TICKET_LIST',
    TICKET_LIST_SIDEBAR: 'TICKET_LIST_SIDEBAR',
    PREMATCH_CASHIN_TICKETS: 'PREMATCH_CASHIN_TICKETS',
    PREMATCH_OVERVIEW: 'PREMATCH_OVERVIEW',
    PREMATCH_OVERVIEW_ON_TICKETS: 'PREMATCH_OVERVIEW_ON_TICKETS',
    PREMATCH_DETAIL: 'PREMATCH_DETAIL',
    PREMATCH_DETAIL_MY_TICKETS: 'PREMATCH_DETAIL_MY_TICKETS',
    LIVE_OVERVIEW: 'LIVE_OVERVIEW',
    LIVE_OVERVIEW_TICKET_LIST: 'LIVE_OVERVIEW_TICKET_LIST',
    LIVE_DETAIL: 'LIVE_DETAIL',
    LIVE_DETAIL_MATCH_LIST: 'LIVE_DETAIL_MATCH_LIST',
    LIVE_DETAIL_MY_TICKETS: 'LIVE_DETAIL_MY_TICKETS',
    COMMUNITY_TICKET_DETAIL: 'BETBOOK_TICKET_DETAIL'
};
